import { Badge, BadgeProps, Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

interface StatusBadgeProps extends BadgeProps {
  tone?: StatusTone;
  children: ReactNode;
}

const toneStyle: Record<StatusTone, Pick<BadgeProps, 'bg' | 'color' | 'borderColor'>> = {
  success: { bg: 'status.success.bg', color: 'status.success.fg', borderColor: 'status.success.border' },
  warning: { bg: 'status.warning.bg', color: 'status.warning.fg', borderColor: 'status.warning.border' },
  danger: { bg: 'status.danger.bg', color: 'status.danger.fg', borderColor: 'status.danger.border' },
  info: { bg: 'status.info.bg', color: 'status.info.fg', borderColor: 'status.info.border' },
  neutral: { bg: 'status.neutral.bg', color: 'status.neutral.fg', borderColor: 'status.neutral.border' },
};

export function StatusBadge({ tone = 'neutral', children, ...props }: StatusBadgeProps) {
  return (
    <Badge
      borderRadius="glassPill"
      borderWidth="1px"
      px="2"
      py="0.5"
      fontWeight="600"
      {...toneStyle[tone]}
      {...props}
    >
      <Box as="span" lineHeight="1">
        {children}
      </Box>
    </Badge>
  );
}
